// extracted by mini-css-extract-plugin
export var feesSection = "eye-examinations-module--feesSection--u8kv6";
export var feeItem = "eye-examinations-module--feeItem--CoyQb";
export var servicesSection = "eye-examinations-module--servicesSection--JaJ2G";
export var bannerSection = "eye-examinations-module--bannerSection--C-xHw";